/**
 *
 * Asynchronously loads the component for DownloadRequests
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DownloadRequests = lazyLoad(
  () => import('./index'),
  module => module.DownloadRequests,
);
